(function () {
    'use strict';

    angular.module("imApp").factory("businessService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1144,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1145,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
